import React, { useState } from "react";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import GuestHeader from "./GuestHeader";
import GuestSidebar from "./GuestSidebar";

const GuestLayout: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const handleClose = () => setDrawerOpen(false);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <GuestHeader toggleDrawer={toggleDrawer} />
      <GuestSidebar
        open={drawerOpen}
        handleClose={handleClose}
        toggleDrawer={toggleDrawer}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerOpen ? 240 : 72}px)` },
          transition: "width 0.3s ease",
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default GuestLayout; 